import { type Issue } from "@overmap-ai/common"
import { selectIssueById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo } from "react"

import { IssueTypeIcon } from "../../../../components/Icons/IssueTypeIcon"
import { IssueIndexLabel } from "../../../../components/IndexLabels/IssueIndex"
import { useAppSelector } from "../../../../store"

export const IssueMentionComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const { uuid } = node.attrs as { uuid: Issue["uuid"] }

	const issue = useAppSelector(selectIssueById(uuid))

	return (
		<NodeViewWrapper
			className="bg-(--base-a3) py-0.25 inset-ring inset-ring-(--base-a6) rounded-md px-1 align-bottom"
			as="span"
		>
			{!!issue && (
				<Link
					className="whitespace-nowrap"
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/issues/$issueId"
					params={(prev) => ({ ...prev, issueId: issue.uuid })}
				>
					<IssueTypeIcon issueTypeId={issue.issue_type} background={false} className="align-sub" />
					<IssueIndexLabel issueId={issue.uuid} />
				</Link>
			)}
		</NodeViewWrapper>
	)
})
IssueMentionComponent.displayName = "IssueMentionComponent"
